import type { ReactNode } from "react";
import { ContourField } from "@mineoptics/brand/canvas/ContourField";

interface Props {
  eyebrow: string;
  title: string;
  lede?: ReactNode;
  children?: ReactNode;
}

/** Opening block of every page except the home page. */
export function PageHero({ eyebrow, title, lede, children }: Props) {
  return (
    <section data-theme="dark" className="relative overflow-hidden bg-bg">
      <div className="absolute inset-0">
        <ContourField className="h-full w-full" focus={[0.84, 0.35]} strength={0.75} />
      </div>
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(9,11,10,0.9)_0%,rgba(9,11,10,0.45)_55%,transparent_100%)]" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-bg to-transparent" />

      <div className="shell relative pb-16 pt-40 md:pb-24 md:pt-56">
        <p data-fade data-now data-delay="0.05" className="eyebrow eyebrow-mark mb-6 text-mute">
          {eyebrow}
        </p>
        <h1 data-split data-now data-delay="0.1" className="title max-w-[15ch]">
          {title}
        </h1>
        {lede && (
          <p data-fade data-now data-delay="0.45" className="lede mt-8 max-w-[52ch] text-fg/75">
            {lede}
          </p>
        )}
        {children && (
          <div data-fade data-now data-delay="0.6" className="mt-10 flex flex-wrap gap-3">
            {children}
          </div>
        )}
      </div>
    </section>
  );
}
